import React, { Component } from 'react'
import IndexList from "./IndexList";
import TabList from "./tablist/TabList";

import db from '../../../assets/icon_db.png'
import zczc from '../../../assets/icon_zczc.png'
import dqzc from '../../../assets/icon_dqzc.png'
import xx from '../../../assets/icon_xx.png'
import qs from '../../../assets/icon_qs.png'
import zr from '../../../assets/icon_zr.png'

import TodoList from "./tablist/TodoList";
import NoRepayment from "./tablist/NoRepayment"
import LiangXin from "./tablist/LiangXin"
import PaymentXin from "./tablist/PaymentXin"
import Payment from "./tablist/PayMent"
import StaticReport from "./tablist/StaticReport"
import { Modal,message } from 'antd';
import style from './index.css';

const cnyFormat = (num,len) => {
  if(!num) return '0.00'
  if(num=='0.00') return '0.00'
  num = num*1
  var c=num.toFixed(len).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
  return c
}

export default class Factor extends Component {
  state = {
    root: [
      {
        name: '供应商',
        code: '03',
      },
      {
        name: '核心企业',
        code: '01',
      },
      {
        name: '蒙元保理商',
        code: '04',
      },
      {
        name: '核心企业子公司',
        code: '02',
      },
      {
        name: '蒙牛集团',
        code: '05',
      }
    ],
    list: [
      // {
      //   id:4,
      //   img:xx,
      //   type:'我的消息',
      //   count: '2',
      //   root:['01','02','03','04','05'],
      //   component: <MsgList></MsgList>
      // },
      {
        id:1,
        img:db,
        type:'我的待办',
        count: '0',
        format: false,
        root:['01', '02', '03', '04', '05'],
        component: <TodoList getCount={(count)=>{this.getCount(count,'我的待办')}}></TodoList>
      },

      {
        id:9,
        img:zr,
        type:'总授信额度',
        field: 'creditAmt',
        format: cnyFormat,
        prefix: '￥',
        count: '0',
        root:['01', '02'],
        component: null,
      },
      {
        id:10,
        img:zr,
        type:'授信使用额度',
        field: 'usedAmt',
        format: cnyFormat,
        prefix: '￥',
        count: '0',
        root:['01', '02'],
        component: null,
      },
      {
        id:11,
        img:zr,
        type:'授信余额',
        field: 'usabledAmt',
        format: cnyFormat,
        prefix: '￥',
        count: '0',
        root:['01', '02'],
        component: null,
      },


      {
        id:2,
        img:zczc,
        type:'待还款',
        field: 'toFactoringAmt',
        format: cnyFormat,
        prefix: '￥',
        count: '0',
        root:['01', '02'],
        component: <NoRepayment></NoRepayment>
      },
      {
        id:2,
        img:zczc,
        type:'未回款金额',
        TabPaneName: '待还款',
        field: 'toRepayAmt',
        format: cnyFormat,
        prefix: '￥',
        count: '0',
        root:['04'],
        component: <NoRepayment></NoRepayment>
      },
      {
        id:3,
        img:dqzc,
        type:'已融资',
        field: 'raisedAmt',
        format: cnyFormat,
        prefix: '￥',
        count: '0',
        root:['03'],
        component: null,
      },
      {
        id:5,
        img:qs,
        type:'已融资笔数',
        field: 'fincCount',
        format: false,
        count: '0',
        root:['04'],
        component: null,
      },
      {
        id:6,
        img:zr,
        type:'已还款',
        field: 'repayAmt',
        format: cnyFormat,
        prefix: '￥',
        count: '0',
        root:['04'],
        component: <Payment></Payment>
      },
      {
        id:7,
        img:zr,
        type:'放款总金额',
        field: 'factoringAmt',
        format: cnyFormat,
        prefix: '￥',
        count: '0',
        root:['04'],
        component: null
      },
      {
        id:8,
        img:qs,
        type:'统计报表',
        field: 'staticReport',
        format: cnyFormat,
        prefix: '￥',
        count: '0',
        root:['04'],
        component: <StaticReport></StaticReport>
      },
    ]
  }
  componentDidMount(){
    let qualTyps = tool.getCookie('qualTyps')
    console.log('1',qualTyps)
    // 判断登录用户是否为准入用户
    let hasRoles = tool.getCookie('roleCodes')
    if(!hasRoles){
      return tool.popUIByUcv('scfp_UI_012015',null, '企业信息')
    }
    this.getCollect()
    this.getCollectAdd()
    this.getHasRaised()
    this.checkInfo()
  }
  
  // 校验角色打开融资失败单号弹窗(客户经理/业务主管)
  checkInfo = () => {
    let list = tool.getCookie('roleCodes').split(',')
    if(!list.includes('ROLE20220124002') && !list.includes('ROLE20230621001') ){
      return
    } 
    const param = {
        "values": {
            "ap": "mn",
            "source": "imp",
            "roleCodes": tool.getCookie('roleCodes'),
            "prodCode": "mn0000",
            "fincStatus": 59
        },
        "matchs": {
            "source": "NotEqualTo"
        }
    }
    commonClient.simplecall(sgiConfig.service_finc + "/finc/list", param, (res) => {
      if(res.head.code === '0000'){
        if(res.body && res.body.length > 0){
          let arr = res.body.map((el) => {
            return el.batchCode
          })
          this.warning(arr.join('，'))
        }
      } else {
        message.error(res.head.msg);
      }
    },false,null,null,(request)=>{
      request.head.pageSize = 50
      request.head.offset = 1
      request.head.queryTotal = "1"
    })
    
  }

  warning = (text) =>{
    Modal.warning({
      className:style.checkInfoModal,
      title: '保理融资调账成功付款失败，需阻止调账单据与工厂回款单据',
      content: <div className={style.overflowHidden } style={{webkitBoxOrient:`vertical`}}>
        融资单号：{text}
      </div>,
    });
  } 
  // 融资汇总
  getCollect = () => {
    commonClient.simplecall(sgiConfig.service_finc + '/finc/statistics/fincsums', {}, (res) => {
      console.log(res.body)
      this.setState((preState, props) => {
        let l = preState.list.map((el) => {
          if(el.field){
            return {
              ...el,
              count: res.body[el.field]
            }
          }else{
            return el
          }
        })
        return {
          list: l
        }
      })
    })
  }

  getHasRaised = () => {
    let req = {
      ap: "mn", 
      entId: tool.getCookie('orgId')
    }
    commonClient.simplecall(sgiConfig.service_finc + 'finc/statistics/entsums', req, (res) => {
      console.log(res.body)
      let fieldMap = {
        raisedAmt: 'factoringAmt',
        toFactoringAmt: 'toFactoringAmt',
      }
      this.setState((preState, props) => {
        let l = preState.list.map((el) => {
          if(fieldMap[el.field]){
            return {
              ...el,
              count: res.body[fieldMap[el.field]]
            }
          }else{
            return el
          }
        })
        return {
          list: l
        }
      })
    })
  }

  getCount = (count, type) => {
    console.log('count',count)
    this.setState((preState, props) => {
      let l = preState.list.map(el=>{
        if(el.type === type) {
          return {
            ...el,
            count
          }
        }else {
          return el
        }
      })
      return {
        list: l
      }
    })
  }

  
  getCollectAdd = () => {
    commonClient.simplecall(sgiConfig.service_crdt + "/credit/list", {  
      values:{
        ap: 'mn',
        expireDate: new Date().format("yyyy-MM-dd"),
        entId: tool.getCookie("enterpriseId")
      },
      matchs: {
        entNam: "CenterLike",
        expireDate: "GreaterThanOrEqualTo",
      }
    }, (res) => {
      console.log(res.body)
      if(!res.body || res.body.length === 0) return
      let fieldMap = {
        creditAmt: 'creditAmt',
        usedAmt: 'usedAmt',
        usabledAmt: 'usabledAmt',
      }
      this.setState((preState, props) => {
        let l = preState.list.map((el) => {
          if(fieldMap[el.field]){
            return {
              ...el,
              count: res.body[0][fieldMap[el.field]]
            }
          }else{
            return el
          }
        })
        return {
          list: l
        }
      })
    })
  }

  render() {
    let { list } = this.state
    let isAdmin = tool.getCookie('roleCodes').includes('ROLE20211207005')
    if(isAdmin){
      list = list.filter(el=>{
        return !['待还款', '已融资', '我的待办', '统计报表', '总授信额度', '授信使用额度', '授信余额'].includes(el.type)
        // return el.type!=='我的待办'
      })
    }
    let mockroots = tool.getCookie('qualTyps') //获取资格codelist

    console.log('mockroots', mockroots, list)
    if(mockroots&&mockroots.length){
      list = list.filter(el=>{
        return el.root.some(ele=>{
          return mockroots.includes(ele)
        })
      })
    }
    
    let lenMap = {
      1:24,
      2:12,
      3:8,
      4:6,
      5:8,
      6:8,
      7:8
    }
    let span = lenMap[list.length]
    return (
      <div>
        <IndexList list={list} span={span}></IndexList>
        <TabList list={list}></TabList>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./apps/pages/main/workbench/Factor/index.js